<template>
    <modal class="yuZhiPrintModel" :isShow="isShow"  @keyup.esc="hide">
        <div class="header">制作单打印分配</div>
        <div class="modal-body">
            <div class="content-box">
                <div class="table-box">
                    <el-table class="el-table--scrollable-y" ref="tableEl" :data="tableList"  highlight-current-row style="width: 100%;" 
                        v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}">
                        <el-table-column prop="IssueType_Name" label="出单类型" width="150"></el-table-column>
                        <el-table-column label="出单关联打印机" min-width="200">
                            <template #default="scope">
                                <el-select v-model="scope.row.Printer_ID" placeholder="请选择打印机"  @focus="$refs.tableEl?.setCurrentRow(scope.row)">
                                    <el-option :value="item.Printer_AutoID" :label="`【${item.Printer_Desc}】${item.Printer_Name}`" v-for="item in printers" :key="item"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="是否打印制作单" width="150">
                            <template #header>
                                <el-checkbox label="是否打印制作单" v-model="checkAll" :indeterminate="isIndeterminate" @change="handleCheckAllChange"/>
                            </template>
                            <template #default="scope">
                                <el-checkbox v-model="scope.row.Is_Print"/>
                            </template>
                        </el-table-column>
                        <el-table-column label="外卖制作单模板" min-width="200" align="center">
                            <template #default="scope">
                                <el-select v-model="scope.row.PrintModel_ID" placeholder="请选择打印模板" @focus="$refs.tableEl?.setCurrentRow(scope.row)">
                                    <el-option :value="item.PrintModel_AutoID" :label="item.PrintModel_Name" v-for="item in yzd_printModels" :key="item"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn selected" @click="saveClick()">保存</button>
        </div>
    </modal>
</template>
<script>

export default {
    name:"yuZhiPrintModel",
    emits:["close"],
    props:{
        isShow:{
            type:Boolean,
            default:false
        },
    },
    data(){
        return {
            tableList:[],
            varietySelect:"",
            //打印机数据
            printers:[],
            //全选
            checkAll:false,
            printModels:[],
        }
    },
    computed:{
        //全部选中状态
        isIndeterminate(){
            return this.tableList?.some(it=>it.Is_Print) && !this.isChecked;
        },
        //是否有勾选的
        isChecked(){
            if(this.tableList?.length>0){
                return !this.tableList?.some(it=>!it.Is_Print);
            }
            return false;
        },
        //预制单 模板 
        yzd_printModels(){
            return this.printModels.filter(t=>t.PrintModel_Type==834);
        },
    },
    watch:{
        isChecked(newVal){
            this.checkAll=newVal;
        }
    },
    mounted(){
        this.$cacheData.Printers().then((d)=>{
            this.printers=d;
        }).catch(e=>{
            console.log('打印机数据获取失败e:'+e)
        })
        this.$cacheData.PrintModels().then(d=>{
            this.printModels=d?.map(it=>{
                let json=Object.assign({},it);
                if(json.IsGroup){
                    json.PrintModel_Name='【区域】-'+json.PrintModel_Name;
                }else if(json.IsPublic){
                    json.PrintModel_Name='【公有】-'+json.PrintModel_Name;
                }else{
                    json.PrintModel_Name='【私有】-'+json.PrintModel_Name;
                }
                return json;
            })
        }).catch(e=>{
            console.log('打印模板数据获取失败e:'+e)
        });
        this.loadData();

        
    },
    methods:{
        hide(){
            this.$emit("close");
        },
        //获取制作单打印机设置
        loadData(){
            let userInfo = this.$auth.getUserInfo();
            const loading = this.$loading({
                text: "获取数据中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
           
            this.$httpAES.post("Bestech.CloudPos.GetPremadePrinter", {
                User_ID:userInfo.User_ID,
                Operate_User:userInfo.Login_Name
            }).then((d)=>{
                console.log(d)
                loading.close();
                if(d.ResponseHeader.ResultCode!=0){
                    this.$message.error(d.ResponseHeader.ResultDesc)
                    return;
                }else{
                    this.tableList=d.ResponseBody;
                    this.pageIndex=1;
                }
            }).catch((e)=>{
                loading.close();
                this.$alert("AI点餐功能的注册信息数据加载失败"+e.message, "提示", {confirmButtonText: "确定"});
            });
        },
        /**保存 */
        saveClick(){

            let premadePrintSets=this.tableList.filter(it=>it.Is_Print);
            
            try {
                premadePrintSets.forEach(it=>{
                    if(!it.Printer_ID){
                        this.$refs.tableEl?.setCurrentRow(it);
                        throw `【${it.IssueType_Name}】请设置打印机!`;
                    }
                    if(it.Is_Print && !it.PrintModel_ID){
                        this.$refs.tableEl?.setCurrentRow(it);
                        throw `【${it.IssueType_Name}】请选择打印模板!`;
                    }
                })
            } catch (error) {
                this.$message.warning(error);
                return;
            }

            //制作单打印机设置
            const loading = this.$loading({
                text: "制作单打印机设置保存中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let userInfo= this.$auth.getUserInfo();
            this.$httpAES.post("Bestech.CloudPos.SetPremadePrinter",{
                User_ID:userInfo.User_ID,
                Operate_User:userInfo?.Login_Name,
                PremadePrintSets:premadePrintSets
            }).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    this.$message.success("保存成功");
                    this.hide();
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                loading.close();
                this.$message.error('保存失败：'+e.message);
                console.log('保存失败：',e);
            })
        },
        handleCheckAllChange(isBo){
            this.tableList.forEach(it=>{
                it.Is_Print=isBo;
            })
        }
    }
}
</script>
<style lang="scss">
@import './yuZhiPrintModel.scss'
</style>